// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../rescript/lib/es6/array.js";
import * as $$String from "../../../../rescript/lib/es6/string.js";
import * as Belt_List from "../../../../rescript/lib/es6/belt_List.js";
import * as Pervasives from "../../../../rescript/lib/es6/pervasives.js";

var listToReactArray = $$Array.of_list;

function sliceList(lst, startOpt, end_) {
  var start = startOpt !== undefined ? startOpt : 0;
  return Belt_List.keepWithIndex(lst, (function (param, idx) {
                if (idx < end_) {
                  return idx >= start;
                } else {
                  return false;
                }
              }));
}

function optionIntToString(a) {
  if (a !== undefined) {
    return String(a);
  }
  
}

function optionBoolToString(a) {
  if (a !== undefined) {
    return Pervasives.string_of_bool(a);
  }
  
}

function optionFloatToString(a) {
  if (a !== undefined) {
    return a.toString();
  }
  
}

function optionStringToReactText(a) {
  if (a !== undefined) {
    return {
            TAG: /* Text */0,
            _0: a
          };
  } else {
    return /* NoText */0;
  }
}

function convertBoolToViewString(a) {
  return $$String.uppercase_ascii(Pervasives.string_of_bool(a));
}

export {
  listToReactArray ,
  sliceList ,
  optionIntToString ,
  optionBoolToString ,
  optionFloatToString ,
  optionStringToReactText ,
  convertBoolToViewString ,
  
}
/* No side effect */
